import React from 'react';

const RelatedPosts = () => {
  const posts = [
    {
      id: 1,
      image: '/home-3/blog/1.png',
      category: 'EDUCATION',
      title: 'Eco-Education in Our Lives: We Can Change the Future',
      date: 'December 16, 2022'
    },
    {
      id: 2,
      image: '/home-3/blog/2.png',
      category: 'EDUCATION',
      title: 'Eco-Education in Our Lives: We Can Change the Future',
      date: 'December 16, 2022'
    },
    {
      id: 3,
      image: '/home-3/blog/3.png',
      category: 'EDUCATION',
      title: 'Eco-Education in Our Lives: We Can Change the Future',
      date: 'December 16, 2022'
    },
    {
      id: 4,
      image: '/home-3/blog/4.png',
      category: 'EDUCATION',
      title: 'Eco-Education in Our Lives: We Can Change the Future',
      date: 'December 16, 2022'
    }
  ];

  return (
    <section className="pt-12 md:pt-16 lg:pt-20 bg-light-5 dark:bg-dark-1 pb-6 rounded-xl sm:px-6 lg:px-[90px]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="flex justify-center text-center mb-8 md:mb-12">
          <div className="max-w-2xl">
            <h2 className="text-2xl md:text-[30px] font-bold mb-2 text-dark-1 dark:text-white">Related Posts</h2>
            <p className="text-gray-600 dark:text-gray-400 text-sm md:text-[15px]">10,000+ unique online course list designs</p>
          </div>
        </div>

        {/* Posts Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {posts.map((post, index) => (
            <div
              key={post.id}
              className="overflow-hidden w-full h-auto sm:h-[373px]"
              data-aos="fade-up"
              data-aos-delay={(index + 1) * 100}
            >
              {/* Post Image */}
              <div className="h-40 sm:h-[210px] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Post Content */}
              <div className="pt-4 sm:pt-6">
                <a href="#" className="text-xs sm:text-sm font-medium text-light-1 dark:text-gray-400
                hover:text-purple-1 dark:hover:text-purple-300">
                  {post.category}
                </a>
                <h3 className="text-sm sm:text-[17px] my-2 line-clamp-2">
                  <a href="#" className="text-dark-4 dark:text-gray-300 hover:text-purple-1 dark:hover:text-purple-300">
                    {post.title}
                  </a>
                </h3>
                <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">{post.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedPosts;